"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useMultiSelectInline = useMultiSelectInline;
exports.MultiSelectInline = MultiSelectInline;
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _SelectInline = require("../SelectInline");

var _useMultiSelectState = _interopRequireDefault(require("../useMultiSelectState"));

function useMultiSelectInline(props) {
  var controller = (0, _useMultiSelectState["default"])(props);
  return (0, _objectSpread2["default"])({}, controller, {
    selectableProps: (0, _SelectInline.getSelectableProps)(controller, props)
  });
}

function MultiSelectInline(_ref) {
  var controller = _ref.controller,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["controller"]);

  if (!controller) {
    controller = useMultiSelectInline(props);
  }

  return (0, _SelectInline.getChildren)(controller, props);
}

var _default = MultiSelectInline;
exports["default"] = _default;